import React from "react";

import { Box, Stack } from "@origin-digital/ods-core";

import { IISolarBatteryOutlookResponse } from "@/contract/generated/electrify-v1";

import { EntireCost, Summary } from "./components";
import { solarBatteryOutlook as content } from "./content.json";
import { Solar } from "./components/Solar";
import { Battery } from "./components/Battery";

type SingleSystemProps = {
  solarBatterySystem: IISolarBatteryOutlookResponse;
};

export const SingleSystem = ({ solarBatterySystem }: SingleSystemProps) => {
  return (
    <Stack space={["large", "xlarge"]} data-id={content.testId.singleSystem}>
      <Box paddingTop="none" paddingX="none">
        <Summary solarBatterySystem={solarBatterySystem} />
      </Box>

      <Box
        display="flex"
        flexDirection={{ xs: "column", lg: "row" }}
        marginX="none"
        marginTop="none"
      >
        <EntireCost solarBatterySystem={solarBatterySystem} />
      </Box>

      <Box
        display="flex"
        flexDirection={{ xs: "column", lg: "row" }}
        marginX="none"
        marginTop="none"
      >
        <Solar solarBatterySystem={solarBatterySystem} />
      </Box>

      <Box
        display="flex"
        flexDirection={{ xs: "column", lg: "row" }}
        marginX="none"
        marginTop="none"
      >
        <Battery solarBatterySystem={solarBatterySystem} />
      </Box>
    </Stack>
  );
};
